export const environment = {
  production: true,
  buildId: '2621734045618071',
  configFile: 'config.json',
};
